import { v4 as uuid } from 'uuid';
import { compact, map } from 'lodash';
import { toUUID } from '../../util/transform';
import JobType from '../job/JobType';
import Root from '../Root';
import type { IStage } from './Stage.interface';
import StageOptionsMessages from './StageOptionsMessages';

export default class Stage extends Root implements IStage {
  idTeamMembers: Array<string>;
  idChecklists: Array<string>;
  idMessages: Array<string>;
  idDocuments: Array<string>;
  opMessages: Array<StageOptionsMessages>;
  jobTypes: Array<JobType>;
  name: string;
  probability: number;
  rottingAfter: number;
  isFactFindEditable: boolean;
  isMilestone: boolean;

  getName() {
    return this.name;
  }

  static build = (data: IStage) => new Stage(data);
  static blank = () => new Stage({ id: uuid(), isActive: true });

  /**
   * Constructor
   * @param {IStage} data
   */
  constructor(data?: IStage) {
    super('__struct', data);

    this.idTeamMembers = compact(map(data?.idTeamMembers, (obj) => toUUID(obj)));
    this.idChecklists = compact(map(data?.idChecklists, (obj) => toUUID(obj)));
    this.idMessages = compact(map(data?.idMessages, (obj) => toUUID(obj)));
    this.idDocuments = compact(map(data?.idDocuments, (obj) => toUUID(obj)));
    // TODO: data?.idMessagesOptions is legacy data structure
    this.opMessages = map(
      data?.idMessagesOptions || data?.opMessages,
      (obj) => new StageOptionsMessages(obj)
    );
    // TODO: data?.idMessagesOptions is legacy data structure
    this.jobTypes = map(data?.jobTypes, (obj) => new JobType(obj));
    this.name = data?.name || '';
    this.probability = parseFloat(data?.probability || 0);
    this.rottingAfter = parseFloat(data?.rottingAfter || 0);
    this.isFactFindEditable = data?.isFactFindEditable === true;
    this.isMilestone = data?.isMilestone === true;
  }
}
